import React from 'react';
import styles from '../styles.scss';
import classNames from 'classnames';

interface IProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const ModalTitle: React.FC<IProps> = ({ children, style, className }: IProps) => {
  const newStyles = {
    ...style,
  };

  return (
    <span className={classNames(styles.modalContainerTitle, className)} style={newStyles}>
      {children}
    </span>
  );
};

export default ModalTitle;
